export const BO_LIST_MAX_RECORDS = 1000;

export const BACKEND_CRON_JOBS_FOLDER = '/workspace/nomachine/projects/backend/src/cron/jobs';

// Needs to be configured in Vite routing
export const BETTER_AUTH_BASEPATH = '/apibo/auth';
export const BETTER_AUTH_BASEPATH_USER = '/apibo/auth_user';

export const MAX_PLAN_ID = 4;
export const FREE_PLAN_ID = 1;
export const BASIC_PLAN_ID = 2;
export const PLUS_PLAN_ID = 3;
export const PRO_PLAN_ID = 4;

export const HEADER_BYPASS_RESTRICTION = "bypass-restriction";
export const basePath = '/app'
export const PBK_ENDPOINT = "/apibo/pbk";

// Company email addresses
export const SUPPORT_EMAIL = 'support@nomachine.dev';
export const DPO_EMAIL = 'dpo@nomachine.dev';
export const LEGAL_EMAIL = 'legal@nomachine.dev';

// Email Theme Constants (matching MUI theme from softTheme.ts)
export const THEME_PRIMARY_MAIN = "#0070f3";
export const THEME_PRIMARY_DARK = "#0761d1";
export const THEME_PRIMARY_LIGHT = "#3291ff";
export const THEME_SECONDARY_MAIN = "#7928ca";
export const THEME_SECONDARY_DARK = "#4c2889";
export const THEME_SECONDARY_LIGHT = "#8a63d2";
export const THEME_BG_PAPER = "#ffffff";
export const THEME_BG_DEFAULT = "#fafafa";
export const THEME_TEXT_PRIMARY = "#111111";
export const THEME_TEXT_SECONDARY = "#666666";
export const THEME_DIVIDER = "#eaeaea";
export const THEME_BORDER_RADIUS = "8px";
export const THEME_FONT_FAMILY = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

// Email template helper function
export const createStyledEmail = (params: {
	heading: string;
	body: string;
	buttonText: string;
	buttonUrl: string;
}): string => {
	const { heading, body, buttonText, buttonUrl } = params;

	return `
<!DOCTYPE html>
<html lang="en">
<head>
	<meta charset="UTF-8">
	<meta name="viewport" content="width=device-width, initial-scale=1.0">
	<meta http-equiv="X-UA-Compatible" content="IE=edge">
	<title>${heading}</title>
	<!--[if mso]>
	<style type="text/css">
		body, table, td {font-family: Arial, sans-serif !important;}
	</style>
	<![endif]-->
</head>
<body style="margin: 0; padding: 0; background-color: ${THEME_BG_DEFAULT}; font-family: ${THEME_FONT_FAMILY};">
	<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: ${THEME_BG_DEFAULT};">
		<tr>
			<td style="padding: 40px 20px;">
				<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 600px; margin: 0 auto; background-color: ${THEME_BG_PAPER}; border: 1px solid ${THEME_DIVIDER}; border-radius: ${THEME_BORDER_RADIUS};">
					<!-- Header -->
					<tr>
						<td style="padding: 40px 40px 24px 40px; text-align: center; border-bottom: 1px solid ${THEME_DIVIDER};">
							<h1 style="margin: 0; font-size: 24px; font-weight: 600; color: ${THEME_TEXT_PRIMARY}; line-height: 1.4;">${heading}</h1>
						</td>
					</tr>

					<!-- Body -->
					<tr>
						<td style="padding: 32px 40px; color: ${THEME_TEXT_SECONDARY}; font-size: 16px; line-height: 1.7;">
							${body}
						</td>
					</tr>

					<!-- Button -->
					<tr>
						<td style="padding: 0 40px 40px 40px; text-align: center;">
							<table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin: 0 auto;">
								<tr>
									<td style="border-radius: ${THEME_BORDER_RADIUS}; background-color: white;">
										<a href="${buttonUrl}" target="_blank" style="display: inline-block; padding: 12px 32px; font-family: ${THEME_FONT_FAMILY}; font-size: 16px; font-weight: 600; color: black; text-decoration: none; border-radius: ${THEME_BORDER_RADIUS};">
											<b>${buttonText}</b>
										</a>
									</td>
								</tr>
							</table>
						</td>
					</tr>

					<!-- Footer -->
					<tr>
						<td style="padding: 24px 40px; text-align: center; border-top: 1px solid ${THEME_DIVIDER}; color: ${THEME_TEXT_SECONDARY}; font-size: 14px; line-height: 1.6;">
							<p style="margin: 0 0 8px 0;">© ${new Date().getFullYear()} NoMachine. All rights reserved.</p>
							<p style="margin: 0;">
								<a href="https://www.nomachine.dev/privacy" target="_blank" style="color: ${THEME_PRIMARY_MAIN}; text-decoration: none;">Privacy Policy</a>
							</p>
						</td>
					</tr>
				</table>

				<!-- Spacer for better rendering -->
				<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 600px; margin: 0 auto;">
					<tr>
						<td style="padding: 16px 40px; text-align: center; color: ${THEME_TEXT_SECONDARY}; font-size: 12px; line-height: 1.5;">
							If the button doesn't work, copy and paste this link into your browser:<br/>
							<a href="${buttonUrl}" target="_blank" style="color: ${THEME_PRIMARY_MAIN}; text-decoration: none; word-break: break-all;">${buttonUrl}</a>
						</td>
					</tr>
				</table>
			</td>
		</tr>
	</table>
</body>
</html>
	`.trim();
};
